import styled, { css } from 'styled-components';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';
import { FlexColumn, FlexibleDiv } from '../../../../styled/common';

export const ParamsSectionContainer = styled.div`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding-bottom: 30px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
  }
`;

export const ParamsContainer = styled(FlexibleDiv)`
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 15px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 10px;
  }
`;

export const ParamsItem = styled(FlexColumn)`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 14px;
  padding: 10px;
  width: calc(50% - 10px);
  gap: 4px;

  @media (min-width: ${Breakpoints.tablet}px) {
    width: calc(50% - 15px);
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    width: calc(25% - 9px);
    padding: 15px;
  }
`;

export const ParamsItemTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const buttonStyles = css`
  height: 48px;
  transition: all 0.2s ease-in-out;

  span {
    border: none;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 10px 35px;
    width: max-content;
    margin: 0 auto;
  }

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.colors.background.tertiary};
    }
  }
`;
